module.exports = __webpack_public_path__ + "static/media/google-play-store-logo.dfa8128d.svg";